/**
 * Página de Análisis de Márgenes
 * Dashboard de márgenes con métricas y análisis de rentabilidad
 */

import React from "react";
import {
  Box,
  Stack,
  CircularProgress,
  Alert,
  Typography,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import { useDashboardOverview } from "../hooks/useAnalytics";
import MarginsLevel1 from "../components/MarginsLevel1";

const MargenesPage: React.FC = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  const dashboardQuery = useDashboardOverview();

  if (dashboardQuery.isLoading) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="400px"
      >
        <Stack spacing={2} alignItems="center">
          <CircularProgress size={60} />
          <Typography variant="h6" color="text.secondary">
            Cargando datos de márgenes...
          </Typography>
        </Stack>
      </Box>
    );
  }

  if (dashboardQuery.isError) {
    return (
      <Alert severity="error" sx={{ mb: 2 }}>
        Error al cargar los datos de márgenes. Verifique que la API esté
        disponible en /api y que la variable VITE_API_URL esté configurada si
        aplica.
      </Alert>
    );
  }

  return (
    <Box sx={{ p: isMobile ? 2 : 3 }}>
      <Stack spacing={3}>
        <MarginsLevel1 />
      </Stack>
    </Box>
  );
};

export default MargenesPage;
